// Old IE exposes the language under these names.
type LegacyNavigator = Navigator & {
  userLanguage?: string;
  browserLanguage?: string;
};

export function getLocale(): string {
  return navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language ||
        (navigator as LegacyNavigator).userLanguage ||
        (navigator as LegacyNavigator).browserLanguage ||
        "en";
}
